import React from "react";
import NestedDropdown from "@techsoftware/happay-widgets/NestedDropdown";

export default class CustomNestedDropdown extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            dataConfig,
            parentWrapperClass,
            filterLogic,
            isClearable,
            disabled,
            required,
            searchInputPlaceholder,
            placeholder,
            onChange,
            data,
            noMatchMessage,
            value,
            borderType,
            tooltipClassName,
            id,
            errorText,
            floatingLabelText
        } = this.props;
        return (
            <NestedDropdown
                {...this.props}
                id={id}
                floatingLabelText={floatingLabelText}
                placeholder={placeholder}
                searchInputPlaceholder={searchInputPlaceholder}
                required={required}
                disabled={disabled}
                isClearable={isClearable}
                filterLogic={filterLogic}
                noMatchMessage={noMatchMessage}
                errorText={errorText}
                data={data}
                dataConfig={dataConfig}
                value={value}
                borderType={borderType}
                tooltipClassName={tooltipClassName}
                parentWrapperClass={parentWrapperClass}
                onChange={onChange}
            />
        );
    }
}
